import { css, keyframes } from 'styled-components';

export const fadeIn = css`
  animation: fadeIn ease-out 200ms;
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const toggleVisible = css`
  opacity: 1;
  visibility: visible;
  transition:
    visibility 0s linear 0s,
    opacity 200ms,
    transform 300ms;
`;

/**
 * [fadeInAnimation]
 * For use in a styled-component. Causes the element to fade in from 0 opacity,
 * when it is rendered to the screen.
 * @param  {String} duration [Optional] Animation duration.
 * @param  {String} easing   [Optional] Easing function.
 * @return {String}
 */
const DEFAULT_DURATION = '1.5s';
const fadeInAnimation = keyframes`
	from, 50%, 80%, to {
		animation-timing-function: cubic-bezier(.51, 0, .35, 1);
	}
	from {
		opacity: 0;
		transform: translate3d(0, 250px, 0);
	}

	80% {
		opacity: 1;
	}

	to {
		opacity: 1;
		transform: translate3d(0, 0, 0);
	}
`;

export const fadeInImageAnimation = ({ duration } = { duration: DEFAULT_DURATION }) => {
  return css`
    animation: ${fadeInAnimation} ${duration};
    animation-fill-mode: both;
  `;
};

/**
 * [bounceInAnimation]
 */
const ZOOM_MAX = 1.07;
const ZOOM_MIN = 0.97;
const DEFAULT_BOUNCE_DURATION = `0.75s`;

const bounceIn = keyframes`
  from,
  20%,
  40%,
  60%,
  80%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    transform: scale3d(${ZOOM_MAX}, ${ZOOM_MAX},${ZOOM_MAX});
  }
  60% {
    opacity: 1;
  }
  70% {
    opacity: 1;
    transform: scale3d(${ZOOM_MIN}, ${ZOOM_MIN},${ZOOM_MIN});
  }
  80% {
    opacity: 1;
    transform: scale3d(1, 1, 1);
  }
  to {
    opacity: 1;
    transform: scale3d(1, 1, 1);
  }
`;

export default function bounceInAnimation({ duration } = { duration: DEFAULT_BOUNCE_DURATION }) {
  return css`
    animation: ${bounceIn} ${duration};
    animation-fill-mode: both;
  `;
}

// animation that works for text of height 12px, if used again should have variable offsets
export const fadeToTextAnimation = keyframes`
    0% {
     opacity: 0;
     transform: translate3d(0, 8px, 0);
    }
    10% {
     opacity: 1;
     transform: translate3d(0, 8px, 0);
    }
    50% {
      opacity: 1;
      transform: translate3d(0, 8px, 0);
    }
    51% {
      opacity: 0;
    }
    60% {
      opacity: 0;
      transform: translate3d(0, -9px, 0);
    }
    70% {
      opacity: 1;
      transform: translate3d(0, -9px, 0);
    }
    100% {
      opacity: 1;
      transform: translate3d(0, -9px, 0);
    }
`;

export const slideFromRight = keyframes`
    0% {
      transform: translateX(100%);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
`;

export const slideToRightOutOfFrame = keyframes`
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-100%);
    }
`;
